/**
 * Maps common React Spectrum v3 semantic tokens to CSS values for layout compat.
 * @see https://react-spectrum.adobe.com/v3/react-spectrum/View.html
 */
export function mapSpacingToken(value?: string): string | undefined {
  if (!value) return undefined;
  if (value.startsWith("size-")) {
    const map: Record<string, string> = {
      "size-0": "0",
      "size-25": "2px",
      "size-50": "4px",
      "size-75": "6px",
      "size-100": "8px",
      "size-150": "12px",
      "size-200": "16px",
      "size-250": "20px",
      "size-300": "24px",
      "size-400": "32px",
      "size-500": "40px",
      "size-600": "48px",
      "size-700": "56px",
      "size-800": "64px",
      "size-900": "72px",
      "size-1000": "80px",
      "size-1200": "96px",
      "size-1600": "128px",
      "size-2000": "160px",
      "size-2400": "192px",
      "size-3000": "240px",
      "size-3400": "272px",
      "size-3600": "288px",
      "size-4600": "368px",
      "size-5000": "400px",
      "size-6000": "480px",
    };
    return map[value] ?? value;
  }
  return value;
}

export function mapColorToken(token?: string): string | undefined {
  if (!token) return undefined;
  const map: Record<string, string> = {
    "gray-50": "#f8f8f8",
    "gray-75": "#f0f0f0",
    "gray-100": "#f4f4f4",
    "gray-200": "#eaeaea",
    "gray-300": "#e0e0e0",
    "gray-400": "#d3d3d3",
    "gray-500": "#b3b3b3",
    "gray-600": "#959595",
    "gray-700": "#767676",
    "gray-800": "#505050",
    "gray-900": "#2c2c2c",
  };
  return map[token] ?? token;
}

export function mapBorderRadiusToken(token?: string): string | undefined {
  if (!token) return undefined;
  const map: Record<string, string> = {
    small: "4px",
    medium: "8px",
    large: "12px",
  };
  return map[token] ?? token;
}
